import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import React from 'react';
import { GlobalDropDown } from '../components/GlobalDropDown';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { ChipDirective, ChipListComponent, ChipsDirective, SwitchComponent } from '@syncfusion/ej2-react-buttons';
interface IProps {
  selectedName: string;
  dateRangePickeValue?: any;
  dateRangePickerOnChange?: (args: any) => void;
  texboxRef: (scope: TextBoxComponent) => void;
  dropDownRef: (scope: DropDownListComponent) => void;
  onChange?: (e: any) => void;
  isVisible?: boolean;
  onCapacitySwitchChange?: (e: any) => void;
}
function TPlannerNoteContent({
  dateRangePickerOnChange,
  dateRangePickeValue,
  selectedName,
  texboxRef,
  dropDownRef,
  onChange,
  isVisible,
  onCapacitySwitchChange,
}: IProps) {
  var selectedChip: Array<any> = [0, 1];
  var deleteExceptionSwichValue1: boolean = true;
  var deleteCapacitySwichValue1: boolean = true;

  const isChipClicked1 = (e: any) => {
    if (e.index === 0) {
      deleteExceptionSwichValue1 = e.selected;
      if (!e.selected) {
        selectedChip.shift();
      } else {
        selectedChip.unshift(0);
      }
    } else if (e.index === 1) {
      deleteCapacitySwichValue1 = e.selected;
      if (!e.selected) {
        selectedChip.pop();
      } else {
        selectedChip.push(1);
      }
    }
  };
  return (
    <div>
      <div>
        <div className='row'>
          <div className='col-md-3'>Name:</div>
          <div className='col-md-5'>
            <div className='form-group'>
              <label className='control-label'>{selectedName}</label>
            </div>
          </div>

          {
            isVisible &&(
              <>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', alignContent: 'flex-end', marginRight: '-20' }}>
            <label className='control-label'>Clear existing shift and exceptions</label>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', alignContent: 'flex-end' }}>

            <div className='col-md-2'>
              <span>Exception:</span>
            </div>
            <div className='col-md-2'>
              <SwitchComponent
                id='switch-is-exception-yes-no'
                change={() => { }}
                onLabel={'on'}
                offLabel={'off'}
                enableRtl={true}
                checked={true}
              />
            </div>
            <div className='col-md-2'>
              <span>Capacity:</span>
            </div>
            <div className='col-md-2'>
              <SwitchComponent
                id='switch-is-shift-yes-no'
                change={onCapacitySwitchChange}
                onLabel={'on'}
                offLabel={'off'}
                enableRtl={true}
                checked={true}
              />
            </div>
          </div>
          <br/></>
            )
          }
        </div>
        <div className='row mb-3'>
          <div className='col-md-3'>Note:</div>
          <div className='col-md-9'>
            <div className='form-group'>
              <TextBoxComponent
                created={() => {
                  //   noteDesc &&
                  //     noteDesc.addAttributes({ rows: 5 })(
                  //       (noteDesc.respectiveElement.style.height = '200px')
                  //     )((noteDesc.respectiveElement.style.overflow = 'auto'))(
                  //       (noteDesc.respectiveElement.style.maxHeight = '200px')
                  //     );
                }}
                ref={(scope: any) => {
                  texboxRef(scope);
                }}
                multiline={true}
                style={{ maxHeight: '100px' }}
              />
            </div>
          </div>
        </div>

        <div className='row mb-3'>
          <div className='col-md-3'>Type:</div>
          <div className='col-md-9'>
            <GlobalDropDown
              id='gc-dropdown'
              field={{ value: 'value', text: 'alias' }}
              url='global-filter?where=tradeplanner$type$isEnabled€1'
              refDD={(ref: DropDownListComponent) => {
                dropDownRef(ref);
              }}
              onChange={onChange}
            />
          </div>
        </div>
        {isVisible && (
          <div className='row mb-3'>
            <div className='col-md-3'>Range:</div>
            <div className='col-md-9'>
              <DateRangePickerComponent
                onChange={dateRangePickerOnChange}
                delayUpdate={true}
                cssClass='customCSS '
                format={'dd/MM/yyyy'}
                id='daterangepicker'
                placeholder='Select a range'
                value={dateRangePickeValue}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TPlannerNoteContent;
